var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcInputPlus = function SvgIcInputPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5A1.5 1.5 0 0 1 6.5 11h12a1.5 1.5 0 0 1 0 3h-12A1.5 1.5 0 0 1 5 12.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5A1.5 1.5 0 0 1 14 6.5v12a1.5 1.5 0 0 1-3 0v-12A1.5 1.5 0 0 1 12.5 5Z"
  })));
};
export default SvgIcInputPlus;